import { ICommonAppState } from "@xala/common-services";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { TextWidgetComponentPoperties as TextWidgetComponentPopertiesDefinition } from "./TextWidgetComponentPoperties";

const mapStateToProps = (state: ICommonAppState) => {
  return {
    isProcessingData: state.applicationConfiguration.isProcessingData,
    sources: state.textComponents,
    files: state.textComponents.fileInfo,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export const TextWidgetComponentPoperties = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(TextWidgetComponentPopertiesDefinition));
